<template>
  <div>
    <label class="tw-font-medium">
      Speakers notes
    </label>
    <SidebarTextArea :initial-text="notesText" />
  </div>
</template>

<script>
import SidebarTextArea from '@frontend/ui/features/checkup/components/sidebar/SidebarTextArea.vue';

export default {
  components: { SidebarTextArea },
  props: ['notes'],
  data() {
    return { /* Local variables */ };
  },
  computed: {
    notesText() {
      if (!this.notes) {
        return 'Loading...';
      }
      const result = this.htmlToPlainText(this.notes);
      console.log('RESULT', result);
      return result;
    },
    /*
    Creates a new property
    Updates when any dependant property changes */
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {

  },
  mounted() {},
  updated() {},
  methods: {
    htmlToPlainText(html) {
      console.log('HTML');
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      return (doc.body.textContent || '').trim();
    },
  },
};
</script>
